import { AppointmentType, NachversandKind } from '@prisma/client';
import { NachversandAppointmentType } from './nachversand-booking-link.dto';

// which Nachversand a booked appointment belongs to, so its Retrieval rows can be found
export const nachversandKindByType: Record<
  NachversandAppointmentType,
  NachversandKind
> = {
  [AppointmentType.NACHVERSAND_BDM1]: NachversandKind.BDM1,
  [AppointmentType.NACHVERSAND_BDM2]: NachversandKind.BDM2,
  [AppointmentType.NACHVERSAND_PART2]: NachversandKind.PART2,
};
